export default "__VITE_ASSET__ed4c0001__"